import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-switch",
  "use": "icon-s-switch-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-switch\"><path d=\"m17.121 15-2.585-2.586L15.95 11l4.95 4.95-4.95 4.95-1.414-1.415L17.02 17H2v-2zM4.778 5H20v2H4.879l2.485 2.485L5.95 10.9 2.05 7H2v-.05l-1-1L5.95 1l1.414 1.414z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol